export default __webpack_public_path__ + "static/updatingData-ff6b6583dbc9388d1babb85fbbf570cd.gif";